import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { currentDate } from "../../helpers/currentDate";
import { ReactComponent as Telegram } from "../../svg/telegram.svg";
import { monthGenerator } from "./helpers/buttonGenerator";
import { fetchData } from '../../helpers/fetchData';
import { titleConverter } from '../../helpers/titleConverter';
import LoadingLazy from '../../components/suspense';
import useFirebase from '../../helpers/firebase';
import { useQuery } from 'react-query';
import CustomSelect from '../../components/teamSelect';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const Bank = React.lazy(() => import("../../components/bank/bank"));
const Bets = React.lazy(() => import("../../components/bets/bets"));
const LastBets = React.lazy(() => import("../../components/lastbets/lastbets"));
const Frequency = React.lazy(() => import("../../components/frequency/frequency"));
const BetsRoi = React.lazy(() => import("../../components/betsRoi/betsroi"));
const Menu = React.lazy(() => import("../../components/menu"))
const TelegramMemo = React.memo(Telegram);

const today = currentDate();

const selectDefaultValue = {label: 'Без фильтра', value: false };
const selectDefaultDate = {label: 'Общая', value: 'Общая'};
const selectDefaultMarket = {label: 'Общая', value: false };

const marketFilterValues = [selectDefaultMarket, {label: 'Исход', value: 'winner'}, {label: 'Тотал', value: 'totals'}]

function Main() {
  const { region, id } = useParams();

  const [firebaseData, firebaseLoading] = useFirebase();

  const isMajor = Boolean(id);

  const dateOptions = monthGenerator(today, isMajor);
  
  const [date, setDate] = useState(() => {
    return isMajor ? selectDefaultDate : currentDate();
  });

  const [teamFilter, setTeamFilter] = useState([selectDefaultValue]);
  const [marketFilter, setMarketFilter] = useState([selectDefaultMarket]);

  useEffect(() => {
      setDate(isMajor ? selectDefaultDate : currentDate());
  }, [isMajor]);

  const { isLoading, data = {} } = useQuery(['botData', region, date, id, teamFilter, marketFilter], () => {
	  const { value } = teamFilter;
	  const { label } = date
	  const { value: MarketValue } = marketFilter;
      return fetchData({region, date: label, id, teamFilter: value, market: MarketValue}).then(res => {
        const [response1, response2] = res;
        const {data: data1} = response1;
        const {data: data2} = response2;
        return { ...data1, matchHistory: data2 }
      })
  })
  
  return (
		<div className="main">
			<div className="container">
				<div className="main_buttons_container">
					<div className="main_buttons_container_faq">
						<Link to="/info/faq" className="main_buttons_faq">
							FAQ
						</Link>
					</div>
					<div className="main_buttons_container_telegram">
						<a href="https://t.me/botggs" target="_blank" without="true" rel="noreferrer" className="main_link">
							<TelegramMemo className="main_logo" />
							Купить подписку на GGS BOT
						</a>
						<a href="https://t.me/GGS_dota" target="_blank" without="true" rel="noreferrer" className="main_link">
							<TelegramMemo className="main_logo" />
							Бесплатная аналитика GGS
						</a>
					</div>
				</div>
				<div className="title_container">
					<h2 className="main_title">{firebaseLoading ? 'Loading...' : titleConverter(region, firebaseData, id)}</h2>
				</div>
				<div>
					<LoadingLazy>
						<Menu />
					</LoadingLazy>
				</div>
				{isMajor ? null : (
					<div className="options">
						<h2 className="options_title">Выбор месяца</h2>
						{!isLoading
							? <CustomSelect options={ dateOptions } defaultValue={dateOptions[0]} onChange={(e) => setDate(isMajor ? selectDefaultDate : e)} value={date} />
							: <div style={{width: '100%'}}><Skeleton inline baseColor={ "#f88324e2" } highlightColor={ "#fc821e" } borderRadius={10} height={42} /></div>
						}
					</div>
				)}
				<div className="options">
					<h2 className="options_title">Фильтр по команде</h2>
					{!isLoading && data.teamOptions.length > 0 
						? <CustomSelect options={data.teamOptions} value={ teamFilter } onChange={(e) => {setTeamFilter(e)}} /> 
						:  <div style={{width: '100%'}}><Skeleton inline baseColor={ "#f88324e2" } highlightColor={ "#fc821e" } borderRadius={10} height={42} /></div>
					}
				</div>
				<div className="options">
					<h2 className="options_title">Фильтр по маркету</h2>
					{!isLoading
						? <CustomSelect options={marketFilterValues} value={ marketFilter } onChange={(e) => {setMarketFilter(e)}} /> 
						:  (<div style={{width: '100%'}}>
							<Skeleton inline baseColor={ "#f88324e2" } highlightColor={ "#fc821e" } borderRadius={10} height={42} />
							</div>)
					}
				</div>
				<>
					<LoadingLazy>
						<Bank
							roi={data.roi}
							maxPick={data.maxPick}
							currentBank={data.currentBank}
							bankHistory={data.bankHistory}
							avgPlusBet={data.avgPlusBet}
							isLoading={isLoading}
						/>
					</LoadingLazy>
					<LoadingLazy>
						<Bets wins={data.wins} lose={data.lose} skip={data.skip} totalBets={data.totalBets} isLoading={isLoading} />
					</LoadingLazy>
					{marketFilter.value !== 'totals' && (
						<>
							<LoadingLazy>
								<Frequency data={data} loading={isLoading} />
							</LoadingLazy>
							<LoadingLazy>
								<BetsRoi data={data} loading={isLoading} />
							</LoadingLazy>
						</>
					)}
					<LoadingLazy>
						<LastBets matchHistory={data.matchHistory} isLoading={isLoading} />
					</LoadingLazy>
				</>
			</div>
		</div>
  );
}

export default Main;
